import { connect } from 'react-redux';
import {
  getProjectZoneId,
  getRevenueChartOptions,
  getRevenueEvents,
  getRevenueExecuteTime,
  getRevenueQueryType,
} from '../../reducers/analyticsApp';
import RevenueMainPane from '../../components/revenue/RevenueMainPane';
import { revenueQueryTypesView } from '../../constants/revenue';

const mapStateToProps = (state) => ({
  options: getRevenueChartOptions(state),
  result: getRevenueEvents(state),
  executeTime: getRevenueExecuteTime(state),
  revenueType: revenueQueryTypesView[getRevenueQueryType(state)],
  timezone: getProjectZoneId(state),
});

export default connect(mapStateToProps)(RevenueMainPane);
